/**
 * TeamSystem Impact - Agent Token API Client
 * CRUD per gestione token MCP agenti
 */

import { apiClient } from '../../../api/client';

export interface AgentTokenDTO {
  _id: string;
  agentId: string;
  agentName: string;
  scopes: string[];
  status: 'active' | 'revoked';
  expiresAt: string;
  lastUsedAt?: string;
  createdAt: string;
}

export interface CreateTokenDTO {
  agentName: string;
  scopes?: string[];
  expiresInDays?: number;
}

interface CreateTokenResponse {
  agentToken: string;
  agentName: string;
  scopes: string[];
  expiresAt: string;
}

interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
}

const BASE_PATH = '/agents/tokens';

export const agentTokenApi = {
  list: async (): Promise<AgentTokenDTO[]> => {
    const response = await apiClient.get<ApiResponse<AgentTokenDTO[]>>(BASE_PATH);
    if (!response.data.success) throw new Error(response.data.error || 'Failed to list tokens');
    return response.data.data!;
  },

  create: async (dto: CreateTokenDTO): Promise<CreateTokenResponse> => {
    const response = await apiClient.post<ApiResponse<CreateTokenResponse>>(BASE_PATH, dto);
    if (!response.data.success) throw new Error(response.data.error || 'Failed to create token');
    return response.data.data!;
  },

  revoke: async (agentId: string): Promise<void> => {
    const response = await apiClient.delete<ApiResponse<void>>(`${BASE_PATH}/${agentId}`);
    if (!response.data.success) throw new Error(response.data.error || 'Failed to revoke token');
  },
};
